var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuganodes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 43,
    viewBox: "8 -5 40 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5049 32.3125H20.7649L20.7756 32.0487L21.7624 7.77252L34.1621 21.0116L26.609 31.8787L26.3075 32.3125H26.8304H42.0929H42.3648L42.3638 32.0363L42.3167 19.4757L51.6488 32.2017L51.73 32.3125H51.866H55.7105H56.25L55.9277 31.873L41.1005 11.6521L40.8773 11.3479L40.662 11.6578L36.2912 17.947L20.4816 1.06442L20.2457 0.8125L20.0586 1.10364L0.273541 31.8869L0 32.3125H0.500336H20.5049Z",
    fill: "#BE1E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuganodes);
export default __webpack_public_path__ + "static/media/luganodes.b4836a7b387acbaff8d4c0174a625e6e.svg";
export { ForwardRef as ReactComponent };